import { toggleModal as _toggleModal } from '../actions';

export function toggleModal(params) {
  return async dispatch => {
    try {
      dispatch(_toggleModal(params));
    } catch (e) {
      // Handle failure when an indication is needed
    }
  };
}
